
export default class Calculations {
    /*
     * Calc Repayments - Capital (monthly)
     *
     * @param     {integer} amtBorrow  
     * @param     {integer} intRate 
     * @param     {integer} mortTerm  
     * @return    {integer} 
    */
    calcRepaymentsCapital(amtBorrow, intRate, mortTerm) {
        var capital_repayments = (amtBorrow * (intRate * Math.pow(1 + intRate, mortTerm))) / (Math.pow(1 + intRate, mortTerm) - 1);
        //alert("Capital: " + capital_repayments);
        return capital_repayments;
    }

    /*
     * Calc Repayments - Interest only (monthly)
     *
     * @param     {integer} amtBorrow  
     * @param     {integer} intRate 
     * @return    {integer} 
    */
    calcRepaymentsInterest(amtBorrow, intRate) {
        var interest_repayments = (amtBorrow * intRate);
        return interest_repayments;
    }



    /*
     * Get Income / Expenditure total
     *
     * @param     {HTMLElement} el
     * @param     {array} setFields  
     * @return    {integer} 
     */
    calculateTotal(el, setFields = []) {
        let applicantFields = el.querySelectorAll('.applicant-field'),
            otherIncomemultiplier = 1,
            outstandingDebtRate = 0.03,
            total = 0;

        if (!setFields.length) {
            applicantFields.forEach(field => {
                let amount = parseInt(field.value) || 0
                if (field.dataset.name === 'app1_OthEmpAcceptable') {
                    amount = amount * otherIncomemultiplier
                }
                if (field.dataset.name === 'overdraft') {
                    amount = amount * outstandingDebtRate
                }
                total += amount;
            })
        } else {
            applicantFields.forEach(field => {
                let amount = parseInt(field.value) || 0
                for (let index = 0; index < setFields.length; index++) {
                    const setField = setFields[index];
                    if (field.dataset.name === setField) {
                        if (field.dataset.name === 'app1_OthEmpAcceptable') {
                            amount = amount * otherIncomemultiplier
                        }
                        if (field.dataset.name === 'overdraft') {
                            amount = amount * outstandingDebtRate
                        }
                        total += amount;
                    }
                }
            })
        }
        return total
    }

    /*
     * Calculate Loan to value
     *
     * @param     {integer} amtBorrow
     * @param     {integer} propertyValue  
     * @return    {integer} 
    */
    calculateLtv(amtBorrow, propertyValue) {
        let ltv = amtBorrow / propertyValue
        return ltv
    }

    /*
     * Validate Fields
     *
     * @param     {array} fields
     * @return    {boolean} 
    */
    validateFields(fields) {
        let errors = 0
        fields.forEach((input) => {
            const errorClass = 'form-group-error',
                  value = input ? input.value : '',
                  group = input.closest('.form-group')
            group.classList.remove(errorClass)
            // remove class from parent
            if (value === '') {
                // add class to parent
                group.classList.add(errorClass)
                errors++
            }
        });

        if(errors > 0) {
            return true
        }
        return false
    }

    calcPayRate(loanAmt, intRate, stressRate){
		var pay_rate = (((loanAmt*intRate)*stressRate)/1200).toFixed(2);
		return pay_rate;
	}
}
